import { Box, SxProps } from "@mui/material";

import preimageVirtualTourViewerLogo from "../../assets/images/preimageVirtualTourViewerLogo.svg";

interface PreimageLogoProps {
  style?: SxProps;
}

const PreimageLogo = ({ style }: PreimageLogoProps) => {
  return (
    <Box
      component="img"
      sx={{ ...style }}
      alt="logo"
      src={preimageVirtualTourViewerLogo}
    />

    // {theme.palette.mode === "light" ? (
    //   <Box
    //     component="img"
    //     sx={{ ...style, ...styles.hideXS }}
    //     alt="logo"
    //     src={PreimageLogoLight}
    //   />
    // ) : (
    //   <Box
    //     component="img"
    //     sx={{ ...style, ...styles.hideXS }}
    //     alt="logo"
    //     src={PreimageLogoDarkBeta}
    //   />
    // )}
  );
};

export default PreimageLogo;
